<template>
  <div>
    <v-row>
      <v-col>
        <!-- <v-text-field
          solo
          v-model="password"
          label="Password"
          class="login-pass"
          ref="loginPass"
          id="loginPass"
          name="loginPass"
          autocomplete="new-password"
          :prepend-inner-icon="icons.mdiAccountKey"
          :type="showPass ? 'text' : 'password'"
          @click:append="showPass = !showPass"
          :append-icon="showPass ? icons.mdiEye : icons.mdiEyeOff"
          :error-messages="passErrorMsgs"
          @input="$v.password.$touch()"
          @blur="$v.password.$touch()"
          @keydown.enter="login"
        >
        </v-text-field> -->
        <v-text-field
        solo
        v-model="password"
          label="Password"
          class="login-pass"
          ref="loginPass"
          id="loginPass"
          name="loginPass"
          :type="whatIsTheType"
          :prepend-inner-icon="icons.mdiAccountKey"
          @click:append="showChanges()"
          :append-icon="showPass ? icons.mdiEye : icons.mdiEyeOff"
          :error-messages="passErrorMsgs"
          @input="$v.password.$touch(), getType()"
          @blur="$v.password.$touch(), getType()"
          @keydown.enter="login" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn
          color="secondary"
          class="ma-2 white--text"
          id="signin"
          name="signin"
          @click="login"
        >
          Sign-in
          <v-icon right> {{icons.mdiLogin}} </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import {
  mdiAccount,
  mdiAccountKey,
  mdiEye,
  mdiEyeOff,
  mdiLogin,
} from '@mdi/js';

import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { clients } from '../../util/clients';

export default {
  mixins: [validationMixin],
  validations: {
    password: { required },
  },
  created() {
    this.initFunc();
  },
  computed: {
    inputs() {
      return {
        username: this.username,
        password: this.password,
      };
    },
    passErrorMsgs() {
      const v = this.$v;
      return (!v.password.$dirty) ? [] : [
        ...(v.password.required) ? [] : ['Required'],
      ];
    },
  },

  name: 'LoginUserPass',
  data: () => ({
    icons: {
      mdiAccount,
      mdiAccountKey,
      mdiEye,
      mdiEyeOff,
      mdiLogin,
    },
    showPass: false,
    password: '',
    isPasswordEnableOrNot: false,
    whatIsTheType: 'text',
  }),
  props: {
    title: {
      type: String,
      default: 'Sign-in',
    },
    username: {
      type: String,
      default: '',
    },
  },
  methods: {
    login() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit('login', this.inputs);
      }
    },
    getType() {
      let type = 'password';
      if (this.isPasswordEnableOrNot) {
        if (this.password) {
          if (this.showPass) type = 'text';
          else type = 'password';
        } else type = 'text';
      } else if (this.showPass) type = 'text';
      else type = 'password';
      this.whatIsTheType = type;
    },
    showChanges() {
      this.showPass = !this.showPass;
      this.getType();
    },
    async initFunc() {
      const res = await clients.auth.getStatusOfPassword();
      this.isPasswordEnableOrNot = res.data.passwordStatus || false;
      this.getType();
    },
  },
};
</script>
